<div class="auth-card">
  <!-- Logo -->
  <div class="auth-logo">
    <img src="assets/images/horseloop-logo.png" alt="HorseLoop" />
  </div>

  @if (emailSent) {
    <!-- Success State -->
    <div class="auth-header">
      <h1>{{ 'auth.forgotPassword.success.title' | translate }}</h1>
      <p>{{ 'auth.forgotPassword.success.subtitle' | translate }}</p>
    </div>

    <div class="alert alert-success">
      <i class="fa fa-check-circle"></i>
      <div>
        <strong>{{ 'auth.forgotPassword.success.message' | translate }}</strong>
        <p class="mb-0">{{ 'auth.forgotPassword.success.description' | translate }}</p>
      </div>
    </div>

    <button
      type="button"
      class="btn btn-outline"
      routerLink="/auth/login"
    >
      <i class="fa fa-arrow-left me-2"></i>
      {{ 'auth.common.backToLogin' | translate }}
    </button>
  } @else {
    <!-- Reset Form -->
    <div class="auth-header">
      <h1>{{ 'auth.forgotPassword.title' | translate }}</h1>
      <p>{{ 'auth.forgotPassword.subtitle' | translate }}</p>
    </div>

    <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">
      <!-- Email Field -->
      <div class="form-group">
        <label for="email" class="form-label">{{ 'auth.common.email' | translate }}</label>
        <input
          type="email"
          id="email"
          formControlName="email"
          class="form-control"
          [class.is-invalid]="resetForm.get('email')?.invalid && resetForm.get('email')?.touched"
          [placeholder]="'auth.common.emailPlaceholder' | translate"
          required
        />
        <span *ngIf="resetForm.get('email')?.invalid && resetForm.get('email')?.touched" class="invalid-feedback">
          {{ 'auth.common.emailInvalid' | translate }}
        </span>
      </div>

      <!-- Reset Button -->
      <div class="form-group">
        <button
          type="submit"
          class="btn btn-primary"
          [disabled]="resetForm.invalid || isSubmitting"
        >
          <span *ngIf="!isSubmitting">{{ 'auth.forgotPassword.sendResetLink' | translate }}</span>
          <span *ngIf="isSubmitting">
            <i class="fa fa-spinner spinner me-2"></i>
            {{ 'auth.forgotPassword.sending' | translate }}
          </span>
        </button>
      </div>
    </form>

    <!-- Divider -->
    <div class="auth-divider">
      <span>{{ 'auth.common.or' | translate }}</span>
    </div>

    <!-- Back to Login -->
    <button
      type="button"
      class="btn btn-outline"
      routerLink="/auth/login"
    >
      <i class="fa fa-arrow-left me-2"></i>
      {{ 'auth.common.backToLogin' | translate }}
    </button>
  }
</div>
